import ViewDetails from './ViewDetails';

export default ViewDetails;
